import React from 'react';
import styled from 'styled-components';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import CloseButton from 'src/assets/images/CloseProduct.svg';
import media from 'src/styles/Media.styled';
import {
    updateNavBarPosition,  
} from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Modal = (props) => {
    useEffectWithErrorLogging(() => {
        updateNavBarPosition('absolute');
        return () => {
            updateNavBarPosition('fixed');
        };
    }, []);

    return (
        <>
            <Backdrop
                showBackdrop={props.showBackdrop}
                closeBackdrop={props.closeModal}
                isModal={true}
            />
            <ModalContainer
                onPointerMove={props?.onLoad}
                onTouchMove={props?.onLoad}
                onTouchEnd={props?.onBlur}
                padding={props.padding}
                show={props.showBackdrop}
                width={props.width}
                left={props.left}
                right={props.right}
                top={props.top}
                modalWidth={props.modalWidth}
                modalHeight={props.modalHeight}
                modalMaxHeight={props.modalMaxHeight}
                modalMinHeight={props.modalMinHeight}
                ipadModalHeight={props.ipadModalHeight}
                maxWidth={props.maxWidth}
                smalModalWidth={props.smalModalWidth}
                overflowX={props.overflowX}
                overflowY={props.overflowY}
                border={props.border}
                background={props.background}
                isSurgery={props.isSurgery}
                isAccountPage={props.isAccountPage}
                isAdminPage={props.isAdminPage}
                removeClipPath={props.removeClipPath}
                onLoad={() => updateNavBarPosition('absolute')}
                fromTemplate={props.fromTemplate}
            >                             
                    {props.hideCloseIcon ? null : (
                        <CloseWrapper closeIconStyle={props.closeIconStyle} closeIconZIndex={props.closeIconZIndex} crossMarginTop={props.crossMarginTop} isFromBomChangeNotification={props.isFromBomChangeNotification} >
                        <img 
                        id="modal-close-button-image"   
                            src={CloseButton}
                            width="100%"
                            height="100%"
                            alt="closeButton"
                            onClick={props.closeModal}
                        />
                        </CloseWrapper>
                    )}                
                {/* <ModalContent> */}
                    {props.children}
                {/* </ModalContent> */}
                {/* </div> */}
            </ModalContainer>
        </>
    );
};

export default Modal;

Modal.defaultProps = {
    hideCloseIcon: false,
};

const ModalContainer = styled.div`
    position: fixed;
    // display: flex;
    // flex-direction: column;
    // width: ${({ width }) => (width ? width : '92%')};
    padding: ${({ padding }) => (padding ? padding : '16px')};
    left: ${({ left }) => (left ? left : '4%')};
    top: ${({ top }) => (top ? top : '5%')};
    bottom: ${({ bottom }) => (bottom ? bottom : '5%')};
    border: ${({ border }) => (border ? border : '1px solid #ffff')};
    right: ${({ right }) => (right ? right : '4%')};

    z-index: 99999;
    width: ${(props) =>
        props.modalWidth ? props.modalWidth : props.maxWidth ? '' : '92%'};
    height: ${(props) => (props.modalHeight ? props.modalHeight : '486px')};
    max-height: ${(props) => (props.modalMaxHeight ? props.modalMaxHeight : '')};
    min-height: ${(props) => (props.modalMinHeight ? props.modalMinHeight : '')};
      @media only screen
        and (max-width: 1000px)
        and (max-height: 500px)
        and (orientation: landscape) {
             height: ${(props) => (props.isSurgery && '300px')};
             top: ${( props ) => (props.isSurgery &&  '18%')};
        }
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '')};
    // padding: 16px;
    /* left: ${({ left }) => (left ? left : '4%')}; */
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    margin: auto;
    /* box-sizing: border-box; */
    display: ${(props) => (props.show ? 'block' : 'none')};

    background: ${({ background }) => (background ? background : '#ffffff')};
    box-shadow: 0px 0px 6px #00000029;
    /* border: 16px solid #ffffff; */

    border-radius: 6px;
    clip-path:${(props) => (props.removeClipPath || props.isAccountPage || props.isAdminPage || props.fromTemplate || props.isSurgery ? 'unset': 'inset(0 round 6px)')};
    ${(props) => (props.overflowY ? `overflow-y: ${props.overflowY};` : '')}
    overflow-x: ${(props) => (props.overflowX ? props.overflowX : 'unset')};
    ${media.mediumDevice`
      width: ${(props) =>
            props.smalModalWidth
                ? props.smalModalWidth
                : props.maxWidth
                    ? ''
                    : '92%'};
    `}
    ${media.mobileDevice`
       display: none; 
    `} /* ${media.mediumDevice`
        width: 82%;
        top: 8%;
        bottom: 8%;
        left: 9%;
    `}; */
    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation : landscape){
        height: ${(props) =>
        props.ipadModalHeight
        && props.ipadModalHeight};
    } 
`;

// const ModalContent = styled.div`
//     flex: 1;
//     overflow-y: auto;   
//     width: 100%;
//     &::-webkit-scrollbar {
//         width: 8px;
//         background: black;
//     }
//     &::-webkit-scrollbar-thumb {
//         background: #bdbdbd;
//         border-radius: 4px;
//     }
// `;

const CloseWrapper = styled.div.attrs(props => ({
    id: props.id || undefined
    }))`
    position: absolute;
    top: 20px;
    right: ${({isFromBomChangeNotification, crossMarginTop}) => isFromBomChangeNotification ? '1.8%' : crossMarginTop || '25px'};
    z-index: ${({ closeIconZIndex }) =>
        closeIconZIndex !== undefined ? closeIconZIndex : 9999};
    width: 21px;
    height: 20px;
    cursor: pointer;
    ${({ closeIconStyle }) => closeIconStyle && closeIconStyle}
`;
